/* React hooks */
import { useContext } from "react";
/* Contexts */
import DeceasedContext from "../context/DeceasedProvider";


export default function useDeceased() {
    return useContext(DeceasedContext)
};